import React from 'react'

interface SVGComponentProps {
  svgString: string
}

export function SVGComponent({ svgString }: SVGComponentProps) {
  return <img src={`data:image/svg+xml;base64,${btoa(svgString)}`} />
}
